export default {
    Bankruptcy: {
        casesHeaderFields: [
            {key: 'cs_title', name: 'Case Title'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'chapter', name: 'Chapter'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'},
            {key: 'disposition', name: 'Disposition'}
        ],
        partiesHeaderFields: [
            {key: 'party_name', name: 'Party Name'},
            {key: 'party_role', name: 'Role'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'chapter', name: 'Chapter'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'},
            {key: 'disposition', name: 'Disposition'}
        ],
    },
    Civil: {
        casesHeaderFields: [
            {key: 'cs_title', name: 'Case Title'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'nature_of_suit_code', name: 'NOS'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'}
        ],
        partiesHeaderFields: [
            {key: 'party_name', name: 'Party Name'},
            {key: 'party_role', name: 'Role'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'nature_of_suit_code', name: 'NOS'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'}
        ],
    },
    Criminal: {
        casesHeaderFields: [
            {key: 'cs_title', name: 'Case Title'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'}
        ],
        partiesHeaderFields: [
            {key: 'party_name', name: 'Party Name'},
            {key: 'party_role', name: 'Role'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'}
        ],
    },
    Appellate: {
        casesHeaderFields: [
            {key: 'cs_title', name: 'Case Title'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'nos', name: 'NOS'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'},
        ],
        partiesHeaderFields: [
            {key: 'party_name', name: 'Party Name'},
            {key: 'party_role', name: 'Role'},
            {key: 'court_id', name: 'Court'},
            {key: 'case_no', name: 'Case No'},
            {key: 'nos', name: 'NOS'},
            {key: 'cs_date_filed', name: 'Date Filed'},
            {key: 'cs_date_term', name: 'Date Closed'},
        ],
    },
}



// WEBPACK FOOTER //
// ./src/components/search/results/tableMapper.js